import { de_DE_formal } from "@App/locales/de_DE-formal";
import { de_DE_globalTranslations } from "@App/locales/de_DE-globalTranslations";

export const mahle = {
  ...de_DE_formal,
  ...{
    translation: {
      ...de_DE_globalTranslations.translation,
      "Partnerwerkstaetten in Ihrer Naehe": "Mahle Partnerwerkstätten in Ihrer Nähe",
      garageList: {
        certifiedAirConditioningExpert: "Zertifizierter Experte für Klimatisierung",
      },
      hero: {
        title: "<strong>{{organization}}<br>Werkstatt-Buchung</strong>",
        subtitle: null,
      },
      homeSections: {
        howItWorks: {
          title: "In wenigen Klicks zum Termin in Ihrer {{organization}} Partnerwerkstatt",
          // No paid extras in this whitelabel, so there is nothing to footnote.
          note: "",
          steps: {
            compare: {
              title: "Werkstätten vergleichen",
              description:
                "Suchen Sie sich die Werkstatt aus, die ideal für Sie ist. Im {{organization}} Werkstattnetz " +
                "finden Sie für jedes Fahrzeug den passenden Partner – mit Entfernung und Bewertungen auf einen Blick.",
            },
            appointment: {
              title: "Wunschtermin aussuchen",
              description:
                "Ganz einfach den Termin aussuchen, der in Ihren Kalender passt – mit den freien Zeiten " +
                "der Werkstatt direkt vor Augen.",
            },
            arrival: {
              title: "Entspannt zur Werkstatt kommen",
              description:
                "Die Werkstatt erwartet Sie zum gebuchten Zeitpunkt – ohne Warteschleife und ohne " +
                "Terminabsprache am Telefon.",
            },
            billing: {
              title: "Terminbestätigung per E-Mail",
              description:
                "Sie erhalten eine Bestätigung mit allen Details zu Termin und Werkstatt per E-Mail.",
            },
          },
        },
        benefits: {
          title: "Bestens versorgt im Werkstattnetz von {{organization}}",
          items: {
            oneStop: {
              title: "Großes Serviceangebot",
              description:
                "Klimaservice, Inspektion, Pickerl (HU) oder Reifenwechsel: In den " +
                "Partnerwerkstätten stehen Ihnen viele verschiedene Services zur Auswahl.",
            },
            partner: {
              title: "{{organization}} Partner",
              description:
                "Alle angezeigten Werkstätten sind {{organization}} Partner und arbeiten nach den " +
                "Qualitätsstandards von {{organization}}.",
            },
            originalParts: {
              title: "Ersatzteile in Originalqualität",
              description:
                "{{organization}} Partnerwerkstätten arbeiten immer mit Ersatzteilen in Originalqualität.",
            },
            vehicleData: {
              title: "Daten automatisch an die Werkstatt",
              description:
                "Alle wichtigen Daten werden an die Werkstatt automatisiert übermittelt.",
            },
            certifiedAirConditioning: {
              title: "Zertifizierte Klimaservice-Experten",
              description:
                "Die Partnerwerkstätten sind für den Klimaservice zertifiziert und arbeiten mit dem " +
                "Know-how und der Technik von {{organization}}.",
            },
            manufacturerSpec: {
              title: "Service nach Herstellervorgaben",
              description:
                "Inspektions- und Wartungsarbeiten werden von allen Partnerwerkstätten nach den Vorgaben " +
                "des Fahrzeugherstellers durchgeführt.",
            },
          },
        },
      },
      contact: {
        text: "Haben Sie Fragen zur Buchung? Wir stehen Ihnen zur Seite.",
        email: {
          link: "mailto:werkstatt.finder@mahle.com",
          title: "werkstatt.finder@mahle.com",
        },
      },
      layout: {
        navbar: {
          partnerLogo: {
            alt: "Mahle",
          },
        },
      },
      linkToHome: "https://werkstatt.repareo.de/partner/mahle",
    },
  },
};
